module.exports = __webpack_public_path__ + "static/media/ste_2007_2.4ef94792.jpg";